/**
 * Input for native function execution
 */
export interface NativeInput {
  /**
   * The name of the native function
   */
  function: string;
  /**
   * The arguments to pass to the native function
   */
  arguments?: unknown[];
}
